module.exports = __webpack_public_path__ + "static/media/LittleRedRidingHood.bec4dc28.jpg";